import type { FieldUnitSpec, Measure } from "lab-testing-units";
import { action, makeObservable, observable } from "mobx";

export class DisplayUnits {
  private readonly chosen = observable.map<string, string>();

  constructor(persisted?: Readonly<Record<string, string>> | null) {
    if (persisted) this.chosen.replace(persisted);
    makeObservable(this, { setUnit: action });
  }

  unitFor(key: string, spec: FieldUnitSpec, entered?: Measure | null): string {
    return this.chosen.get(key) ?? entered?.unit ?? spec.canonical;
  }

  setUnit(key: string, unitId: string): void {
    this.chosen.set(key, unitId);
  }

  toJSON(): Record<string, string> | undefined {
    return this.chosen.size > 0 ? Object.fromEntries(this.chosen) : undefined;
  }
}
